module.exports = __webpack_public_path__ + "img/poplar-swatch.53491620.png";